import { render, staticRenderFns } from "./Recommended.vue?vue&type=template&id=0723ad25&scoped=true&"
import script from "./Recommended.vue?vue&type=script&lang=js&"
export * from "./Recommended.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0723ad25",
  null
  
)

export default component.exports